"use strict";

Proj.PopupForms = function(){
       
    var $message = {
        error_load: "Произошла ошибка загрузки данных. Попробуйте перезагрузить страницу"
    };

    function _click_handler(e) {
        e.preventDefault();
        var _self         = $(this),
            _form_id      = _self.data("formId"),
            _form_name    = _self.data("formName") || '',
            _mail_subject = _self.data("maleSubject") || '',
            _prod_id      = _self.data("prodId") || '';

        _load_form(_form_id, _form_name, _prod_id, _mail_subject);
    }

    function _load_form(formId, formName, prodId, mailSubject) {
    	$.fancybox.showLoading();
    	Proj.getJSON({
    		    _do          : 'get_form', 
    		    form_id      : formId,
                form_name    : formName,
                mail_subject : mailSubject,
                prod_id      : prodId
    	    }, _answer);
    }

    function _answer(data) {
    	if(data){
            
            $.fancybox.hideLoading();
            if(data.content) {
            	_show_window(data.content);

            }
    	} else {
    		alert($message.error_load);
    	}
    }

    function _show_window(data) {

    	$.fancybox(data,{
    		autoSize          : true,
            width             : 'auto',
            height            : 'auto',
            type              : 'html',
            openEffect        : 'fade',
            closeEffect       : 'fade',
            minWidth          : 290,
            padding           : 35,
            tpl               : {
				wrap     : '<div class="fancybox-wrap fancybox-wrap--custom" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
				image    : '<img class="fancybox-image" src="{href}" alt="" />',
				iframe   : '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0"' + ($.browser.msie ? ' allowtransparency="true"' : '') + '></iframe>',
				error    : '<p class="fancybox-error">Запрашиваемое содержимое не может быть загружено.<br/>Пожалуйста, повторите запрос позже.</p>',
				closeBtn : '<a title="Закрыть" class="fancybox-item fancybox-close" href="javascript:;"></a>',
				next     : '<a title="Следующий" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
				prev     : '<a title="Предыдущий" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
			},
            helpers : {
                overlay : {
                    locked: false
                }
            }
    	});
       
       //_form_fields(".fancybox-wrap");
       _process_form(".fancybox-wrap");
        
    }

    function _form_fields(dom) {
        var $dom  = $(dom),
            $form = $dom.find("form");

        $form.find('.p').each(function(){
            var _this = $(this);
            
            if(_this.find('.label').length) {
                _this.find('.label').hide();
	            var _placeholder = _this.find('label').text();
	            _this.find('input, textarea').attr('placeholder',_placeholder);
            }
            

        });

        
    }
    

    function _process_form(dom) {
        var $dom    = $(dom),
            $form   = $dom.find("form"),
            $name   = $form.attr("name"),
            $submit = $form.find('button[type="submit"]');

        $submit.on("click", function(e){
            e.preventDefault();
            
            var $data = $form.serializeArray();
            
            $data.push({name: '_do', value: 'submit_form'});

            $form.find(".error").removeClass("error");
            Proj.getJSON($data, function(data){_process_form_answer(data, $form);});

        });
    }

    function _process_form_answer(data, form){

    	if(data) {
    		console.log(data);
    		if(data.status === "error") {
    			var i = 0,
                    l = data.errors.length;
                for(i = 0; i < l; i++) {
                    form.find('.attr-'+data.errors[i]).addClass("error");
                }
    		} else if(data.status === "ok") {
    			form.html(data.content);
    		}
    	} else {
    		alert($message.error_load);
    	}

    }


    function _init_popup_form(selector) {
        var _selector = $(selector) || {};
         
        if(_selector.length) {
            
            _selector.on("click", _click_handler);

        }

    }

    return {

   	    init: function(selector) {
            _init_popup_form(selector);            
   	    }

    }
}();